import { ORDER } from './schema';
import { setNormalizeEntities } from '@/modules/_global/vuex/mutations';

export default {
  setEntities: setNormalizeEntities(),

  setOrderStatuses: (state, statuses) => {
    state.statuses = statuses;
  },

  setSubstitutionOptions: (state, options) => {
    state.substitutionOptions = options;
  },

  setOrders: (state, ordersIds) => {
    state[ORDER] = ordersIds;
  },

  addOrders: (state, orderIds) => {
    orderIds.forEach(orderId => {
      if (state[ORDER].includes(orderId)) {
        return;
      }

      state[ORDER].push(orderId);
    });
  },

  setOrdersParams: (state, ordersParams) => {
    state.ordersParams = ordersParams;
  },

  setCurrentOrder: (state, order) => {
    state.currentOrder = order;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
